import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";
import { TableCellAlignEnum } from "../../../../../components/core/Table/Table";

export const StyledTableGoals = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const StyledTableCell = styled.td<{
  $edit?: boolean;
}>`
  padding: 20px 10px;
  align-content: center;
`;

export const StyledTableCellContent = styled.div<{
  $align?: TableCellAlignEnum;
}>`
  display: flex;
  width: 100%;
  justify-content: ${({ $align }) =>
    $align === TableCellAlignEnum.CENTER
      ? "center"
      : $align === TableCellAlignEnum.RIGHT
        ? "flex-end"
        : "flex-start"};
`;

export const StyledTableHeader = styled.th`
  padding: 20px;
`;

export const StyledTableHeaderContent = styled.div<{
  $align?: TableCellAlignEnum;
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: ${({ $align }) =>
    $align === TableCellAlignEnum.CENTER
      ? "center"
      : $align === TableCellAlignEnum.RIGHT
        ? "flex-end"
        : "flex-start"};
`;

export const StyledTableRow = styled.tr<{ $isHeading?: boolean }>`
  & td:nth-of-type(1) {
    padding: 0px 10px 0px 20px;
    border-radius: ${theme.variables.border_radius_2} 0 0
      ${theme.variables.border_radius_2};
  }
  & td:last-child {
    border-radius: 0 ${theme.variables.border_radius_2}
      ${theme.variables.border_radius_2} 0;
  }
  &:nth-child(even) {
    background-color: ${theme.colors.white};
  }
  &:nth-child(odd) {
    background-color: ${(props) =>
      props.$isHeading ? theme.colors.white : theme.colors.purple_4};
  }
`;

export const StyledGoalsPage = styled.div<{ $hasFooter: boolean }>`
  overflow: hidden;
  height: ${({ $hasFooter }) =>
    $hasFooter ? "calc(100dvh - 400px)" : "calc(100dvh - 329px)"};
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledGoalsScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const StyledBottomDivTable = styled.div<{
  $showAchievementPercentage?: boolean;
}>`
  display: flex;
  justify-content: ${({ $showAchievementPercentage }) =>
    $showAchievementPercentage ? "space-between" : "flex-end"};
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
`;

export const StyledGoalsErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 20px;
`;

export const StyledFinalCalibrationError = styled.span`
  font-size: ${theme.variables.fs_12};
  color: ${theme.colors.red_1};
  font-weight: ${theme.variables.fw_Regular};
`;

export const StyledBoldError = styled.span`
  font-weight: ${theme.variables.fw_semiBold};
  padding: 0px 3px 0px 3px;
`;

export const StyledImpactBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledGoalsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledGoalCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${theme.colors.purple_2};
  padding: 20px;
  border-radius: 12px;
  background-color: ${theme.colors.white};
`;

export const StyledGoalCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const StyledGoalCardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const StyledAchievementPillContainer = styled.div`
  min-width: 200px;
`;

export const StyledAchievementSelect = styled.div`
  width: 200px;
  flex-shrink: 0;
`;

export const StyledGoalCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledChallengeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledChallengeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  background-color: ${theme.colors.grey_6};
  border-radius: ${theme.variables.border_radius_1};
  padding: 12px;
`;

export const StyledChallengeLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledAchievementContainer = styled.div`
  min-width: 50px;
  display: flex;
  justify-content: center;
`;
